<template>
    <div class="ib_wrap" @click="doClick" @keydown="onKeyDown" :tabindex="disabled?-1:tabindex"
            :aria-label="aria?aria:title" role="button" :aria-disabled="disabled"
            :class="{ disabled: disabled }">
        <div ref="icondiv" class="ib2" :class="{autosize: size=='auto'}">
       <slot>
           <div class="icon_wrap" ref="icon" :class="{ disabled: disabled, [iconClass]: !!iconClass }">
                <font-awesome-icon v-if="icon" ref="icon" :icon="icon" :size="size" fixed-width/>
           </div>
        </slot>
            <b-tooltip v-if="title!='' && $mqIs('md+')" :target="()=>$refs.icondiv" :title="title"
                    :disabled="disabled" ref="tooltip" :show.sync="showTooltip" triggers="hover"/>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'iconButton',
  components: { FontAwesomeIcon },
  data: function() {
    return {
      showTooltip: false
    };
  },
  props: {
    icon: {
      type: [ String, Array ]
    },
    iconClass: String,
    size: {
      type: String,
      default: '1x'
    },
    title: String,
    aria: String,
    disabled: Boolean,
    tabindex: {
      type: [ Number, String ],
      default: 0
    }
  },
  watch: {
    disabled(val) {
      if (val) {
        this.showTooltip = false;
      }
    }
  },
  methods: {
    doClick() {
      if (!this.disabled) {
        this.$emit('click');
        // this.$refs.icon.blur();
      }
    },
    onKeyDown(evt) {
      if ((evt.key === ' ') || (evt.key === 'Enter')) {
        this.$emit('click');
        evt.preventDefault();
      } else {
        this.$emit('keydown', evt);
      }
    },
    onToolbarAction(action, tb) {
      if ((action === ' ') || (action === 'Enter')) {
        this.doClick();
        return true;
      }
      // tb.reFocus();
      return false;
    },
    focus() {
      if (this.$refs.icon) {
        this.$refs.icon.focus();
      }
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .ib_wrap {
        padding: 3px;
        margin: -3px 0 0 15px;
        display: inline-block;
        .ib2 &:not(.autosize) {
            width:32px;
        }
        &:not(.disabled) {
            .ib2:hover {
                background-color: $gray-300;
            }
        }

        .icon_wrap {
            cursor: pointer;
            user-select: none;
            color: $black;
            transition: background-color 0.3s;
            border-radius: 0.5em;

            &.disabled {
                cursor: default;
                outline: none;
                color: $gray-400;
                svg {
                    outline: none;
                }
            }
            &.selected {
                background-color: $toolbar-selected;
                outline:none;
            }
            &:focus {
                // background-color: green;
            }
        }

    }
    .dropMenuButton.selected .ib_wrap {
        background-color: $toolbar-selected;
        outline:none;
    }

</style>
